import { combineReducers } from 'redux';

import { SEARCH_LOADED, SEARCH_LOADING } from './searchActions';

const data = (previousState = {}, { type, payload }) => {
  if (type === SEARCH_LOADED) {
    return payload.data;
  }
  return previousState;
}

const loading = (previousState = false, { type, payload }) => {
  if (type === SEARCH_LOADED) {
    return false;
  }
  if (type === SEARCH_LOADING) {
    return true;
  }
  return previousState;
}

const reducer = combineReducers({
  data,
  loading
});

export default reducer;



// WEBPACK FOOTER //
// ./src/components/Search/searchReducer.js